<template>
  <div class="login-view">
    <Logout />
  </div>
</template>

<script>
import Logout from "@/components/templates/Logout";

export default {
  components: { Logout },
};
</script>
